'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');
const Pinterest = require('../../../global/components/Pinterest/Icon');
const PdpFacebookIcon = require('./PdpFacebookIcon');
const PdpEmailIcon = require('./PdpEmailIcon');
const PdpPrintIcon = require('./PdpPrintIcon');
const MediaQuery = require('../../../global/components/MediaQuery');
const {queries} = require('../../../global/core/commonjs/screenSize');

class PdpSocialIcons extends ContextComponent {

    _getPrintIcon() {
        const {printIcon, context} = this.props;

        if (printIcon) {
            return (
                <MediaQuery query={queries.xl}>
                    <PdpPrintIcon context={context} />
                </MediaQuery>
            );
        }

        return null;
    }

    render() {
        const props = this.props;
        const {socialData, pinterest, iconType, onPinterestPin, pinterestConnectAccounts} = props;

        return (
            <div className="pdp-social-icons">
                <Pinterest url={socialData.uri}
                    media={socialData.image}
                    description={socialData.pinterest}
                    onPin={onPinterestPin}
                    copy={pinterest.copy}
                    iconType={iconType}
                    connectAccounts={pinterestConnectAccounts} />
                <PdpFacebookIcon iconType={props.iconType} />
                <PdpEmailIcon id={props.id}
                    vertical={props.vertical}
                    itemPk={props.itemPk}
                    stfOnClick={props.stfOnClick}
                    iconType={props.iconType} />
                {this._getPrintIcon()}
            </div>
        );
    }
}

PdpSocialIcons.propTypes = {
    vertical: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    socialData: PropTypes.object.isRequired,
    itemPk: PropTypes.string.isRequired,
    stfOnClick: PropTypes.func.isRequired,
    pinterest: PropTypes.object.isRequired,
    onPinterestPin: PropTypes.func,
    pinterestConnectAccounts: PropTypes.bool,
    printIcon: PropTypes.bool,
    iconType: PropTypes.string
};

PdpSocialIcons.defaultProps = {
    printIcon: true
};

module.exports = PdpSocialIcons;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/social/PdpSocialIcons.jsx